module.exports = __webpack_public_path__ + "static/media/golf.b478148a.png";